import React, { Component } from 'react';
import '../Public/css/footer.scss';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav, Accordion } from "react-bootstrap";
import { handleActiveLink, handleLeft } from '../../Actions/AllAction';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { setToken, setUserCredentials, logOutApp, userrole } from '../../GlobalModules/Login/Actions/LoginAction';
class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExactSize: false,
        }

    }

    handleImageLoad = (event) => {
        const { naturalWidth, naturalHeight } = event.target;
        if (naturalWidth <= 299 && naturalHeight <= 299) {
            this.setState({ isExactSize: true });
        } else if (naturalWidth <= 501 && naturalHeight <= 501) {
            this.setState({ isExactSize: true });
        } else {
            this.setState({ isExactSize: false });
        }
    };

    render() {
        const { userCredentials } = this.props;
        let org_profile_image = "";
        let marketed_by_logo_url = "";
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('org_logo') && userCredentials.user_details.org_logo && userCredentials.user_details.org_logo.hasOwnProperty('file_obj') && userCredentials.user_details.org_logo.file_obj) {
            org_profile_image = userCredentials.user_details.org_logo.file_obj
        }
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('marketed_by_logo_url') && userCredentials.user_details.marketed_by_logo_url && JSON.parse(userCredentials.user_details.marketed_by_logo_url).hasOwnProperty('img_url') && JSON.parse(userCredentials.user_details.marketed_by_logo_url).img_url) {
            marketed_by_logo_url = userCredentials.user_details.marketed_by_logo_url.img_url
        }

        let plan_name = "";
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('version_description') && userCredentials.user_details.version_description) {
            plan_name = userCredentials.user_details.version_description
        }

        let roleName = "";
        if (userCredentials && userCredentials.user_details && userCredentials.user_details.hasOwnProperty('user_type') && userCredentials.user_details.user_type) {
            roleName = userCredentials.user_details.user_type;
        }
        return (
            <>
                <div className="footer-inner">
                    <div className={marketed_by_logo_url != "" ? "footer-inner-content" : "footer-inner-content noMarketed"}>
                        <div className="content-box">
                            <span className="content-label">Powered By:</span>
                            <a href="https://mettletech.co/" target='_blank'>
                                <img src={require('../Public/images/mettletech-logo3.png')} className="sidebarimg leftLogo" data-tip="Mettle Tech" />
                                <span className="content-label-env">Mettle Tech</span>
                            </a>
                        </div>
                        <div className="content-box content-box-end">
                            {roleName != "app_admin" && ["v3.0.1", "v4", "v5", "v6"].includes(userCredentials?.user_details?.version) && userCredentials?.user_details?.hasOwnProperty('subscription_ended') && userCredentials?.user_details.subscription_ended != null && userCredentials?.user_details.subscription_ended == true ?
                                <p style={{ fontSize: '11px', color: 'red', fontWeight: 600 }}>
                                    No active plans
                                </p>
                                :
                                roleName != "app_admin" ?
                                    <div className='plan_name_label'>

                                        {/* {plan_name == "Pro plan" ?
                                            <img src={require('../Public/images/premium.png')} className="" /> : null}
                                        {plan_name == "Standard plan" ?
                                            <img src={require('../Public/images/premium.png')} className="" /> : null} */}
                                        <img src={require('../Public/images/premium.png')} className="" />
                                        <span>{(plan_name).charAt(0).toUpperCase() + (plan_name).slice(1)}</span>
                                    </div> : null}

                            {marketed_by_logo_url != "" &&
                                <>
                                    <div className="vertical-line"></div>
                                    <div className='marketed_by_box'>
                                        <span className="content-label">Marketed By:</span>
                                        <a className='footer_marketed_logo' href={userCredentials.user_details.marketed_by_url} target='_blank'>
                                            <img src={JSON.parse(userCredentials?.user_details?.marketed_by_logo_url).img_url} className={`${this.state.isExactSize ? 'full-size' : 'half-size'} sidebarimg rightLogo`} onLoad={this.handleImageLoad} data-tip={userCredentials.user_details.marketed_by_name} />
                                            <span className="content-label-env">{userCredentials.user_details.marketed_by_name}</span>
                                        </a>
                                    </div>
                                </>
                            }
                        </div>

                    </div>
                </div>
            </>
        );
    }
}


function mapStateToProps(globalState) {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,

    };
}

export default connect(mapStateToProps, { handleActiveLink, handleLeft, setToken })(withTranslation()(Footer));